export default __webpack_public_path__ + "assets/img/22W8Op6.png";